import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-foreground text-background/90 relative overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-primary/25 blur-3xl"
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 lg:py-20">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-primary text-primary-foreground font-serif-display text-lg">
                C
              </span>
              <span className="font-serif-display text-2xl text-background">
                Care Anywhere
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm text-background/70 leading-relaxed">
              Premium on-location childcare for events, travel, and the moments
              that matter most. Certified, insured, and trusted by families
              worldwide.
            </p>
          </div>

          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-background/60">
              Explore
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#why-us" className="hover:text-primary transition-colors">Why Us</a></li>
              <li><a href="#services" className="hover:text-primary transition-colors">Services</a></li>
              <li><a href="#how-it-works" className="hover:text-primary transition-colors">How It Works</a></li>
              <li><a href="#trust" className="hover:text-primary transition-colors">Trust &amp; Safety</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-background/60">
              Portals
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="/portal/login" data-testid="footer-parent-portal" className="hover:text-primary transition-colors">Parent portal</a></li>
              <li><a href="/careers" data-testid="footer-careers" className="hover:text-primary transition-colors">Careers &amp; applicants</a></li>
              <li><a href="/admin/login" data-testid="footer-admin" className="hover:text-primary transition-colors">Staff &amp; admin</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-background/60">
              Contact
            </div>
            <ul className="mt-5 space-y-3 text-sm text-background/80">
              <li className="flex items-center gap-3">
                <Mail size={14} className="text-primary" />
                concierge.careanywhereagency@gmail.com
              </li>
              <li className="flex items-center gap-3">
                <Phone size={14} className="text-primary" />
                (820) 386-2072
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={14} className="text-primary" />
                Los Angeles, California
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-background/60">
          <div>© {new Date().getFullYear()} Care Anywhere. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-primary transition-colors">Privacy</a>
            <a href="/terms" data-testid="footer-terms" className="hover:text-primary transition-colors">Terms</a>
            <a href="#" className="hover:text-primary transition-colors">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
